import { enableProdMode, NgZone } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/angular/app.module';
import { environment } from './environments/environment';
import { UrlService } from '@uirouter/core';
declare var Keycloak;

if (environment.production) {
  enableProdMode();
}

// Get the subdomain that actora is being accessed from, and attempt to use keycloak config for that subdomain if present
const subdomain = window.location.hostname.split(".")[0];
// set up keycloak using config for specific subdomain
initKeycloak(`${subdomain}-keycloak.json`).error(() => {
  console.debug(`Keycloak initialisation using ${subdomain} realm config failed, falling back to default`);
  // Fall back to the default config if we fail to set up using a subdomain specific config. This should be backwards compatible with the current system.
  initKeycloak('keycloak.json').error(() => {
    alert('failed to initialize keycloak');
  });
});

function initKeycloak(config) {
  (<any>window).keycloakInstance = Keycloak(config);
  return (<any>window).keycloakInstance.init({ onLoad: 'login-required', checkLoginIframe: false }).success((authenticated) => {
    if (authenticated) {
      platformBrowserDynamic().bootstrapModule(AppModule).then(platformRef => {
        const urlService: UrlService = platformRef.injector.get(UrlService);

        function startUIRouter() {
          urlService.listen();
          urlService.sync();
        }

        platformRef.injector.get<NgZone>(NgZone).run(startUIRouter);
      });
    }
  });
}

